import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, getContatById, changeViewForms, updateContact, deletePhone, clickToCall } from '../../services';

import Loading from '../../components/Loading/LoadingModule';
import PhoneCard from './PhoneListShowCard';

import '../../libs/bulma.min.css';
import './ContactsShow.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const EMPTY_ALERT = { show: false, type: '', message: '' };

function ShowContacts() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit, itemsSelectedToEdit, } = getItensStateGlobal;

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [ph, setPh] = useState([]);
  const [alert, setAlert] = useState(EMPTY_ALERT);

  const { changeVisibityMessages } = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    if(itemsSelectedToEdit.length <= 0) return history.push('/agenda/lista');
    const contactFetch = await getContatById({ id: itemsSelectedToEdit });
    if(!contactFetch || !Array.isArray(contactFetch['phones'])) {
      setAlert({ show: true, type: 'danger', message: 'Não foi possível carregar o contato.' });
      return setLoading(false);
    }
    setPh(contactFetch['phones']);
    setValues(contactFetch);
    return setLoading(false);
  }, []);

  const sendDataContactUpdate = async () => {
    setAlert(EMPTY_ALERT);

    const result = await updateContact({
      id: values['idcont'],
      company: values['compname'],
      fantasy: values['namefantasy'],
      addr: values['addr'],
      cnpj: Number(values['cnpj']),
      email: values['mail'],
      alias: values['alias'],
      comment: values['comm'],
    });

    if(!result.success) {
      setAlert({ show: true, type: 'danger', message: result.error });
      return;
    }

    setAlert({ show: true, type: 'success', message: 'Contato atualizado com sucesso!' });
    setItemsSelectedToEdit([values['idcont']]);
    await validateUserLogged();
  };

  const handleClickDeletePhone = async (data) => {
    const { value } = data;
    setAlert(EMPTY_ALERT);

    const result = await deletePhone({ id: Number(value) });

    if(!result.success) {
      setAlert({ show: true, type: 'danger', message: result.error });
      changeVisibityMessages(false, `delete-phone-link-${value}`);
      changeVisibityMessages(true, `delete-phone-confirm-${value}`);
      return;
    }

    if(ph.length === 1) return history.push('/agenda/lista');
    setItemsSelectedToEdit([values['idcont']]);
    await validateUserLogged();
  };

  const handleClickToCall = async (phone) => {
    let phoneFull = phone;
    if(phoneFull.length === 10 || phoneFull.length === 11) phoneFull = `0${phone}`;
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const myEndpoint = {
      name: `${values['namefantasy']}`,
      dest: phoneFull,
      exten: user.endpoint
    };

    const result = await clickToCall(myEndpoint);
    if(!result) setAlert({ show: true, type: 'danger', message: 'Não foi possível iniciar a chamada.' });
  };

  useEffect(() => {
    let cancel = false;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="contacts-show-container">
      {loading ? (
        <Loading />
      ) : (
        <>
            <div className="contacts-show-header">
              <div className="contacts-show-title-wrapper">
                <svg className="contacts-show-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <div>
                  <h1 className="contacts-show-title">Visualizar Contato</h1>
                  <p className="contacts-show-subtitle">Informações do contato</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button className="btn-edit-contact" onClick={() => history.push('/agenda/contato/id')}>
                  <FontAwesomeIcon icon={faSave} />
                  Editar
                </button>
                <Link to="/agenda/lista" className="btn-back">
                  <FontAwesomeIcon icon={faArrowLeft} />
                  Voltar
                </Link>
              </div>
            </div>
            {alert.show && (
              <div className="alerts-section">
                <div className={`alert-message alert-${alert.type}`}>
                  <div className="alert-header">
                    <p>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</p>
                    <button className="alert-close" aria-label="close" onClick={ () => setAlert(EMPTY_ALERT) }>×</button>
                  </div>
                  <div className="alert-body">
                    {alert.message}
                  </div>
                </div>
              </div>
            )}
            <div className="contact-info-card">
              <div className="contact-info-grid">
                <div className="contact-info-item">
                  <span className="contact-info-label">Razão Social:</span>
                  <span className="contact-info-value">{ values['compname'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">CNPJ/CPF:</span>
                  <span className="contact-info-value">{ values['cnpj'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">Nome Fantasia:</span>
                  <span className="contact-info-value">{ values['namefantasy'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">E-mail:</span>
                  <span className="contact-info-value">{ values['mail'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">Endereço:</span>
                  <span className="contact-info-value">{ values['addr'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">Apelido:</span>
                  <span className="contact-info-value">{ values['alias'] }</span>
                </div>
                <div className="contact-info-item contact-info-item-full">
                  <span className="contact-info-label">Comentários:</span>
                  <span className="contact-info-value">{ values['comm'] }</span>
                </div>
              </div>
            </div>
            <div id="list-phones" name="list-phones" className="phones-grid-show">
              { ph.map((phone) => <PhoneCard key={phone.phonenumber} phones={ phone } changeVisibityMessages={ changeVisibityMessages } handleClickToCall={ handleClickToCall } del={ handleClickDeletePhone }/>) }
            </div>
        </>
      )}
    </div>
  );
}

export default ShowContacts;
